import React from "react";
import {
  faInstagram,
  faXTwitter,
  faFacebook,
  faYoutube,
  faTiktok,
  faWhatsapp,
  faGoogle,
  faApple,
  faSpotify,
  faGooglePlay,
} from "@fortawesome/free-brands-svg-icons";
import { FaIcon } from "./fa-icon";
import { faPodcast } from "@fortawesome/pro-light-svg-icons";

const brandIcons = {
  faInstagram: faInstagram,
  faXTwitter: faXTwitter,
  faFacebook: faFacebook,
  faYoutube: faYoutube,
  faTiktok: faTiktok,
  faWhatsapp: faWhatsapp,
  faGoogle: faGoogle,
  faApple: faApple,
  faSpotify: faSpotify,
  faGooglePlay: faGooglePlay,
  faPodcast: faPodcast,
};

export default function CitySocial({ city }) {
  return (
    <>
      {city.socialLinks &&
        city.socialLinks.map((socialLink, index) => {
          const brandIcon = brandIcons[socialLink.icon];

          if (brandIcon) {
            return (
              <a
                key={`brand_icon_${index}`}
                href={socialLink.url}
                target="_blank"
                rel="noreferrer"
                aria-label={socialLink.name}
              >
                <FaIcon icon={brandIcon} />
              </a>
            );
          }

          return <></>;
        })}
    </>
  );
}
